/**
 * useCommunity Hook
 * Fetches community details by ID using React Query
 */

import { useQuery } from "@tanstack/react-query"
import { getCommunityById, getCommunityStatistics } from "../services/community.service"

interface UseCommunityOptions {
  enabled?: boolean
}

export function useCommunity(communityId: string, options?: UseCommunityOptions) {
  return useQuery({
    queryKey: ["community", communityId],
    queryFn: () => getCommunityById(communityId),
    enabled: options?.enabled ?? !!communityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

/**
 * Hook to fetch community statistics
 */
export function useCommunityStatistics(communityId: string, options?: UseCommunityOptions) {
  return useQuery({
    queryKey: ["community-statistics", communityId],
    queryFn: () => getCommunityStatistics(communityId),
    enabled: options?.enabled ?? !!communityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
